import { render, staticRenderFns } from "./test-route.vue?vue&type=template&id=78b97364&scoped=true"
import script from "./test-route.vue?vue&type=script&lang=js"
export * from "./test-route.vue?vue&type=script&lang=js"
import style0 from "./test-route.vue?vue&type=style&index=0&id=78b97364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b97364",
  null
  
)

export default component.exports